import axios, { AxiosError } from "axios";
import { animate } from "animejs";
import orgCode from "library/orgCode";
import App from "library/Global";
import Global from "library/Global";
import Native from "library/native";
import { jwtDecode } from "jwt-decode";
import { Buffer } from "buffer";

// 응답 받기 전 처리
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    // 토큰만료시
    try {
      if (
        error.response?.status === 401 &&
        error.response?.data?.code === "40000"
      ) {
        const oldToken = window.localStorage.getItem("accessToken");
        const info = jwtDecode(oldToken);
        const loginData = {
          ch_user_id: info.ch_user_id,
          gender: info.gender,
          style: "style",
          user_nm: info.user_nm,
        };

        // 2. 토큰 재발급 + 스토리지 저장
        const fetchToken = await Lib.fetchToken(loginData);

        error.config.headers.Authorization = `Bearer ${fetchToken.data.access_token}`;

        const response = await axios.request(error.config);
        return response;
      }

      return Promise.reject(error);

    } catch (error) {
      return Promise.reject(error);
    }
  }
);
// 요청보내기 전 처리
axios.interceptors.request.use(async function (config) {
  // myapi(재판매모델)에서만 확인 환경변수로 처리된 process.env.REACT_APP_MYAPI_SERVER 확인
  // header 토큰정보 유무 확인
  try {
    if (config.url.indexOf(process.env.REACT_APP_MYAPI_SERVER) == 0 && config.headers.Authorization === undefined) {

      // 1. 정보 확인
      const info = App.user;
      const loginData = {
        ch_user_id: info.mbId,
        gender: info.gendr,
        style: "style",
        user_nm: info.mbNm,
      };

      // 2. 토큰 재발급 + 스토리지 저장
      const fetchToken = await Lib.fetchToken(loginData);
      // 3. 요청한 api header에 저장
      config.headers.Authorization = `Bearer ${fetchToken.data.access_token}`;
    }
    // 진행
    return config;

  } catch (error) {
    return Promise.reject(error);
  }
}, function (error) {
  return Promise.reject(error);
}

)



let errorCount = 0
const Lib = {
  /**
   *
   * @param {Number} n
   * @returns {String}
   *  뮨자애 공백 넣기
   */
  _(n = 1) {
    let str = "";
    [...Array(n)].map(() => (str += "\u00a0"));
    return str;
  },

  /**
   *
   * @param {HTMLElement} element
   * @returns {Arry} siblings of element
   * 모든 형제 엘리먼트 찾기
   */
  siblings(element, classSelector) {
    if (!element) return null;
    const children = element.parentElement.children;
    return [...children].filter((item) => {
      let t = false;
      if (item !== element) {
        if (classSelector) {
          if (item.classList.contains(classSelector)) return true;
        } else {
          t = true;
        }
      }
      return t;
    });
  },

  /**
   *
   * @param {HTMLElement} element
   * @returns {Number} index of element
   */
  index(element) {
    return [...element.parentElement.children].indexOf(element);
  },

  //timeout
  timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },

  stop(ms) {
    const wakeUpTime = Date.now() + ms;
    while (Date.now() < wakeUpTime) { }
  },

  // 반올림
  round(number, n = 0) {
    return Math.round(number * Math.pow(10, n)) / Math.pow(10, n);
  },

  /* scrollTo(y = 0) {
    if (typeof document.body.style.scrollBehavior !== "undefined") {
      window.scrollTo(0, y)
    } else if (anime) {
      anime({
        targets: document.scrollingElement,
        scrollTop: y,
        easing: "easeOutExpo"
      })
    }
  }, */

  // 숫자에 , 더하기
  addComma(num) {
    if (this.isNull(num) || isNaN(num)) return;
    var regexp = /\B(?=(\d{3})+(?!\d))/g;
    return num.toString().replace(regexp, ",");
  },

  // 가장 가까운 부모엘리먼트 찾기
  closest(element, selector) {
    let parent = element.parentElement;
    while (parent && parent.classList.contains(selector)) {
      parent = parent.parentElement;
    }
    return parent;
  },

  // 지연 함수
  delay(ms) {
    const now = new Date().getTime();
    while (new Date().getTime() < now + ms) { }
  },

  async fetch(url, option = {}) {
    try {
      const response = await fetch(url, option);
      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      console.error(error);
    }
  },

  /* async fetch(url, option = {}) {
    try {
      const response = await fetch(url, option)
      const data = await response.json()
      return data
    } catch (error) {
      console.log("%c" + error, " color: red ")
    }
  }, */

  /*
    undefined, undefined => arg1 = { method: "post" }
    function, undefined => arg2 = { method: "post" }
    function, object => arg2.data = arg2, arg2.method = "post"
    object, undefined => arg1.data = arg1, arg1.method = "post"
    object, function => arg1.data = arg1, arg1.method = "post"
  */


  getAxiosOption(url, arg1, arg2, arg3, method, arg4) {
    let option = {};
    if (
      typeof url === "string" &&
      typeof arg1 === "object" &&
      typeof arg2 === "function" &&
      typeof arg3 === "function"
    ) {
      option.data = arg1;
      option.url = url;
      option.onSuccess = arg2;
      option.onFail = arg3;
      console.log(`getAxios type 1: ${url}`);
    } else if (
      typeof url === "string" &&
      typeof arg1 === "function" &&
      typeof arg2 === "function"
    ) {
      if (typeof arg3 === "object") option = arg3;
      else if (typeof arg3 === "function") option.onComplete = arg3;
      option.url = url;
      option.onSuccess = arg1;
      option.onFail = arg2;
      if (arg4 && typeof arg4 === 'function') {
        option.onError = arg4;
      }
      console.log(`getAxios type 2: ${url}`);
    } else if (typeof url === "object") {
      option = url;
      if (method === "get" && url.data) {
        option.params = url.data;
      }
      if (method === "post" && url.params) {
        option.data = url.params;
        // timeout 
        if(url.timeout) {
          option.timeout = url.timeout;
        }
      }
      console.log(`getAxios type 3: ${url}`);
    } else {
      if (typeof arg1 === "object") {
        if (method === "post") {
          option.data = arg1;
        } else if (method === "get") {
          option.params = arg1;
        } else if(method === "put") {
          option.data = arg1;
        }
      } else if (typeof arg2 === "object") {
        if (method === "post") {
          option.data = arg2;
        } else if (method === "get") {
          option.params = arg2;
        } else if(method === "put") {
          option.data = arg2;
        }
      }

      if (typeof arg1 === "function") {
        option.onSuccess = arg1;
      } else if (typeof arg2 === "function") {
        option.onSuccess = arg2;
      }
      option.url = url;
      console.log(`getAxios type 4: ${url}`);
    }
    option.method = method;
    return option;
  },

  async post(url, arg1, arg2, arg3) {
    const option = this.getAxiosOption(url, arg1, arg2, arg3, "post");
    return await this.axios(option);
  },

  async get(url, arg1, arg2, arg3, arg4) {
    const option = this.getAxiosOption(url, arg1, arg2, arg3, "get", arg4);
    return await this.axios(option);
  },

  async myPost(url, arg1, arg2, arg3, arg4) {
    const option = this.getAxiosOption(url, arg1, arg2, arg3, "post", arg4);
    return await this.myAxios(option);
  },

  async myGet(url, arg1, arg2, arg3, arg4) {
    console.log("myGEt !!!");
    const option = this.getAxiosOption(url, arg1, arg2, arg3, "get", arg4);
    return await this.myAxios(option);
  },

  // 부동산 API 재판매모델 서버로 연동을 위한 put 추가
  async myPut(url, arg1, arg2, arg3, arg4) {
    const option = this.getAxiosOption(url, arg1, arg2, arg3, "put", arg4);
    return await this.myAxios(option);
  },


  // 재로그인, 토큰 발급
  async fetchToken(loginData) {
    try {
      // 서비스 채널별 인가된 API 확인 API, 로그인 API, 토큰갱신 API 호출시
      let clientId = process.env.REACT_APP_MYAPI_ID;
      let secretKey = process.env.REACT_APP_MYAPI_SECRET_KEY;

      let token = Buffer.from(clientId + ":" + secretKey).toString("base64");

      // 2. 가져온 정보로 토큰 재발급
      const login = await axios
        .post(
          `${process.env.REACT_APP_MYAPI_SERVER}/api/auth/login/v1?grant_type=username`,
          loginData,
          {
            headers: { Authorization: `Basic ${token}` },
          }
        )
        .then((res) => {
          if (res) {
            window.localStorage.setItem("accessToken", res.data.access_token);
            window.localStorage.setItem("refreshToken", res.data.refresh_token);
            // config.headers.Authorization = `Bearer ${res.data.access_token}`;
            return res;
          }
        })

      return login;
      // throw login;
    } catch (error) {
      console.error('토큰 가져오기 실패:', error);
      throw error; // 에러를 그대로 던져서 요청을 중단
    }
  },
  /*
    undefined, undefined => arg1 = { method: "post" }
    function, undefined => arg2 = { method: "post" }
    function, object => arg2.data = arg2, arg2.method = "post"
    object, undefined => arg1.data = arg1, arg1.method = "post"
    object, function => arg1.data = arg1, arg1.method = "post"


    Lib.axios({
      url: "",
      method: "get",
      timeout: 10000,
      onComplete: () => {

      }
    })
  */

  async myAxios(option) {
    console.log(process.env.REACT_APP_MYAPI_SERVER);
    const ourRequest = axios.CancelToken.source();
    const loginAPI = "/api/auth/login/v1"; // 로그인 API
    const refreshAPI = "/api/auth/refresh/v1"; // 토큰갱신 API
    const sncnAPI = "/api/auth/sncnApis/v1"; // 서비스 채널별 인가된 API 확인 API

    let errorHandler, alwaysHandler, callback, failHandler;
    try {
      option.url = process.env.REACT_APP_MYAPI_SERVER + option.url;

      if (
        option.url.indexOf(loginAPI) !== -1 ||
        option.url.indexOf(refreshAPI) !== -1 ||
        option.url.indexOf(sncnAPI) !== -1
      ) {
        // 서비스 채널별 인가된 API 확인 API, 로그인 API, 토큰갱신 API 호출시
        let clientId = process.env.REACT_APP_MYAPI_ID;
        let secretKey = process.env.REACT_APP_MYAPI_SECRET_KEY;

        let token = Buffer.from(clientId + ":" + secretKey).toString("base64");


        if (token) {
          option.headers = {
            Authorization: `Basic ${token}`,
          };
        }
      } else {
        console.log(
          "window.localStorage.getItem('accessToken') : ",
          window.localStorage.getItem("accessToken")
        );
        let access_token = window.localStorage.getItem("accessToken");

        // getAxiosOption를 통해 arg3(object)로 option을 셋팅 시 option에 헤더 셋팅을 하게 되면 아래의 코드로 인해 사라짐.
        // if (access_token) {
        //   option.headers = {
        //     Authorization: `Bearer ${access_token}`,
        //   };
        // }
        if (access_token) {
          console.log(option.headers)
          if (this.isNotNull(option.headers)) {
            console.log('in headers')
            option.headers.Authorization = `Bearer ${access_token}`
            console.log(option.headers)
          } else {
            option.headers = {
              Authorization: `Bearer ${access_token}`,
            };
          }
        }
      }

      if (option.onSuccess) {
        callback = option.onSuccess;
        delete option.onSuccess;
      }
      if (option.onFail) {
        failHandler = option.onFail;
        delete option.onFail;
      }
      if (option.onError) {
        errorHandler = option.onError;
        delete option.onError;
      }
      if (option.onComplete) {
        alwaysHandler = option.onComplete;
        delete option.onComplete;
      }
      const response = await axios(option);
      console.log(response);
      const status = response.status;
      switch (status) {
        case 200:
          if (callback) {
            callback(response.data, ourRequest);
          } else {
            return response.data;
          }

          // if (failHandler) {
          //   failHandler(response.data, new Error());
          // } else if (errorHandler) {
          //   errorHandler(new Error());
          // } else {
          //   App.alert(
          //     `연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
          //   );
          // }
          // if (response.data.code === "S000") {
          //   // Global.sessionTimerReset(Global.isLogin);
          //   if (callback) {
          //     callback(
          //       response.data.result?.data,
          //       response.data.result?.pagination,
          //       ourRequest
          //     );
          //   } else {
          //     return response.data.result?.data;
          //   }
          // } else {
          //   const error = new Error();
          //   error.number = response.data.code;
          //   error.message = response.data.msg;
          //   if (failHandler) {
          //     failHandler(response.data, error);
          //   } else if (errorHandler) {
          //     errorHandler(error);
          //   } else {
          //     App.alert(
          //       `연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
          //     );
          //   }
          // }
          break;

        default:
          //alert(status)

          App.alert(
            `연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
          );
          break;
      }
    } catch (error) {
      if (error.code === "ECONNABORTED") {
        // timeout 에러인 경우
        App.alert(
          `서버와의 통신이 원활하지 않습니다. <br /> 잠시 후 다시 시도해주세요.`
        );
      } else if (error.response && error.response.status && error.response.status === 401) {
        errorCount++
        const user = App.user
        await this.myPost({
          url: `/api/auth/login/v1?grant_type=username`,
          data: {
            ch_user_id: user.mbId,
            gender: user.gendr === "F" ? 2 : "1",
            style: "style",
            user_nm: user.mbNm,
          },
          onSuccess: (data) => {
            if (errorCount == 1) {
              // TODO 코드 공통화 처리 되면 수정사항 발생
              // 로그인(토큰발급) 성공시 accessToken, refreshToken localStorage 저장
              window.localStorage.setItem("accessToken", data.access_token);
              window.localStorage.setItem("refreshToken", data.refresh_token);
              errorCount = 0
            }
          },
          onComplete: () => {
            if (errorCount = 0) {
              this.myAxios(option)
            } else {
              errorCount = 0
              App.alert(
                `연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
              );
            }
          }
        })
        // window.location.reload();
      } else if (errorHandler) {
        errorHandler(error);
      } else {
        if (App.alert) {
          App.alert(
            `연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
          );
        }
      }
    }
    if (alwaysHandler) alwaysHandler();
    if (Global.hideLoading) Global.hideLoading();
  },

  async axios(option) {
    const ourRequest = axios.CancelToken.source();
    let errorHandler, alwaysHandler, callback, failHandler;
    try {
      if (typeof option.withCredentials === "undefined") {
        option.withCredentials = true;
      }
      if (Global.mode !== "development") {
        option.baseURL = process.env.REACT_APP_SERVER;
      }
      // option.baseURL = App.server;
      if (option.onSuccess) {
        callback = option.onSuccess;
        delete option.onSuccess;
      }
      if (option.onFail) {
        failHandler = option.onFail;
        delete option.onFail;
      }
      if (option.onError) {
        errorHandler = option.onError;
        delete option.onError;
      }
      if (option.onComplete) {
        alwaysHandler = option.onComplete;
        delete option.onComplete;
      }

      let access_token = window.localStorage.getItem("accessToken");

      if (access_token) {
        option.headers = {
          Authorization: `Bearer ${access_token}`,
        };
      }

      if (!option.timeout) option.timeout = 1000 * 120; // 120초
      const response = await axios(option);
      const status = response.status;
      switch (status) {
        case 200:
          if (response.data.code === "S000") {
            Global.sessionTimerReset(Global.isLogin);
            if (callback) {
              callback(
                response.data.result?.data,
                response.data.result?.pagination,
                ourRequest
              );
            } else {
              return response.data.result?.data;
            }
          } else {
            const error = new Error();
            error.number = response.data.code;
            error.message = response.data.msg;
            if (failHandler) {
              failHandler(response.data, error);
            } else if (errorHandler) {
              errorHandler(error);
            } else {
              App.alert(
                `연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
              );
            }
          }
          break;
        default:
          //alert(status)
          App.alert(
            `연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
          );
          break;
      }
    } catch (error) {
      if (error.code === "ECONNABORTED") {
        // 마데 연동 중인 케이스 확인.
        if(errorHandler){
          errorHandler(error instanceof AxiosError? error.response : error);
        }else if(failHandler){
          failHandler(error instanceof AxiosError? error.response : error);
        }else{

          // timeout 에러인 경우
          App.alert(
            `서버와의 통신이 원활하지 않습니다. <br /> 잠시 후 다시 시도해주세요.`
          );
        }
      } else if (error.response.status === 401) {
        window.location.reload();
      } else if (errorHandler) {
        
        errorHandler(error instanceof AxiosError? error.response : error);
      } else {
        App.alert(
          `연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
        );
      }
    }
    if (alwaysHandler) alwaysHandler();
    Global.hideLoading();
  },

  // 오브젝트 사이즈를 반환
  size(obj) {
    return Object.keys(obj).length;
  },

  // 캐멀스타일을 하이픈 스타일로
  camelToHypen(str) {
    return str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
  },

  // 한글 마지막 글자 받침 유무
  endWithBase(korStr) {
    const finalChrCode = korStr.charCodeAt(korStr.length - 1);
    // 0 = 받침 없음, 그 외 = 받침 있음
    const finalConsonantCode = (finalChrCode - 44032) % 28;
    return finalConsonantCode !== 0;
  },

  enNeun(text) {
    if (this.endWithBase(text)) {
      return "은";
    } else {
      return "는";
    }
  },

  addEnNeun(text) {
    if (this.endWithBase(text)) {
      return `${text}은`;
    } else {
      return `${text}는`;
    }
  },

  addEulLeul(text) {
    if (this.endWithBase(text)) {
      return `${text}을`;
    } else {
      return `${text}를`;
    }
  },

  eulLeul(text) {
    if (this.endWithBase(text)) {
      return `을`;
    } else {
      return `를`;
    }
  },

  yiga(text) {
    if (this.endWithBase(text)) {
      return "이";
    } else {
      return "가";
    }
  },

  getUserAgent() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) {
      return "android"; // android
    } else if (/ipad|ipod|iphone/.test(userAgent)) {
      return "ios"; //iOS
    } else {
      return "else";
    }

    /* const userAgent = window.navigator.userAgent.toLocaleLowerCase(),
      standalone = window.navigator.standalone,
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent)

    if (ios) {
      if (!standalone && safari) {
        // Safari
        return "safari"
      } else if (!standalone && !safari) {
        // iOS webview
        return "ios"
      }
    } else {
      if (userAgent.includes('wv')) {
        // Android webview
        return "android"
      } else {
        // Chrome
        return "chrome"
      }
    }

    return "else" */
  },

  // 클래스 이름으로 *.module.css 로부터 스타일 찾기
  getStyle(className, styles) {
    if (!className || !styles) return "";
    return className
      .split(" ")
      .map((item) => (styles[item] ? styles[item] : item))
      .join(" ");
  },

  //null 체크
  isNull(value) {
    if (value === null || typeof value === "undefined" || value === "") {
      return true;
    } else {
      return false;
    }
  },

  //null 아닌지 체크
  isNotNull(value) {
    return !this.isNull(value);
  },

  // 미성년체크
  isAdult(birthdate) {
    // 19840815, 1984.08.15, 1984-08-15, 840815, 84.08.15, 84-08-15 의 형태
    if (birthdate.length === 8) birthdate = birthdate.substr(2);
    let year = birthdate.replace(/\.|-/g, "").substr(0, 2);
    if (/^0|^1|^2/.test(year)) {
      year = "20" + year;
    } else {
      year = "19" + year;
    }
    const month = birthdate.substr(2, 2);
    const date = birthdate.substr(4, 2);
    const birth = new Date(`${year}/${month}/${date}`);
    if (isNaN(birth)) return undefined;
    const now = new Date();
    const man = (now - birth) / (1000 * 60 * 60 * 24 * 365);
    if (Number(man) <= 19) {
      return false;
    } else {
      return true;
    }
  },

  // 만나이 계산하기
  getMan(birthdate) {
    const today = new Date();
    let age = today.getFullYear() - birthdate.getFullYear();
    const m = today.getMonth() - birthdate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
      age--;
    }
    return age;
  },

  // 앞에 0 붙이기
  leadingZero(n) {
    if (Number(n) < 10 && Number(n) >= 0) {
      return "0" + n;
    } else {
      return n;
    }
  },

  // regexp 관련 특수문자
  quote(str) {
    return str.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
  },

  // 요일 찾기
  getDay(n) {
    return ["일", "월", "화", "수", "목", "금", "토"][n];
  },

  // 타임스템프에서 일 계산하기
  getDate(n) {
    return Math.ceil(n / 60 / 60 / 24 / 1000);
  },

  // 날짜 포멧에 / 없으면 추가하기 20211225 -> 2021-12-25
  dateFormat(d, seperator = "-") {
    if (!d) return d;
    if (d instanceof Date) {
      const m = d.getMonth() + 1;
      const dt = d.getDate();
      d = `${d.getFullYear()}${m < 10 ? `0${m}` : m}${dt < 10 ? `0${dt}` : dt}`;
    } else if (typeof d === "number") {
      const da = new Date(d);
      return `${da.getFullYear()}${seperator}${this.leadingZero(
        da.getMonth() + 1
      )}${seperator}${this.leadingZero(da.getDate())}`;
    }
    d = d.replace(/\.|-|\//g, "");
    return `${d.substr(0, 4)}${seperator}${d.substr(
      4,
      2
    )}${seperator}${d.substr(6, 2)}`;
  },

  dateFormatKorean(d) {
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const date = d.getDate();
    const day = d.getDay();
    let yoil;
    switch (day) {
      case 0:
        yoil = "일";
        break;
      case 1:
        yoil = "월";
        break;
      case 2:
        yoil = "화";
        break;
      case 3:
        yoil = "수";
        break;
      case 4:
        yoil = "목";
        break;
      case 5:
        yoil = "금";
        break;
      case 6:
        yoil = "토";
        break;
    }
    return `${year}년 ${month}월 ${date}일(${yoil})`;
  },

  // 두 데이트 객체간의 날짜 구하기
  getDday(d1, d2) {
    d1.setHours(0);
    d1.setMinutes(0);
    d1.setMilliseconds(0);
    d2.setHours(0);
    d2.setMinutes(0);
    d2.setMilliseconds(0);
    let dday = d2 - d1;
    return Math.ceil(dday / 1000 / 60 / 60 / 24);
  },

  // transition end event type 찾기
  getTransitionEndType() {
    var transitions = {
      transition: "transitionend",
      OTransition: "oTransitionEnd",
      MozTransition: "transitionend",
      WebkitTransition: "webkitTransitionEnd",
    };
    const bodyStyle = document.body.style;
    for (let transition in transitions) {
      if (typeof bodyStyle[transition] !== "undefined") {
        return transitions[transition];
      }
    }
    return "transitionend";
    // "webkitTransitionEnd oTransitionEnd otransitionend transitionend transitionEnd"
  },

  scrollTo(element, y, easing = "easeOutExpo") {
    if (typeof element === "undefined") {
      element = document.querySelector(".core");
      y = 0;
    } else if (typeof element === "object" && typeof y === "undefined") {
      y = 0;
    } else {
      y = element;
      element = document.querySelector(".core");
    }

    if (typeof document.body.style.scrollBehavior !== "undefined") {
      element.scrollTo(0, y);
    } else if (animate) {
      if (element === window) {
        element =
          window.document.scrollingElement ||
          window.document.body ||
          window.document.documentElement;
      }

      animate(element,{
        scrollTop: y,
        duration: 400,
        ease: easing,
      });
    }
  },

  async getCommonCode(groupCode) {
    const data = await this.get(`/api/comm/cd/${groupCode}`);
    return data;
  },

  readPhoto(e, id) {
    const input = e.target;
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        const img = document.getElementById(id);
        img.src = e.target.result;
        img.style.opacity = 1;
        input.nextElementSibling.classList.add("show");
      };
      reader.readAsDataURL(input.files[0]);
    } else {
      const img = document.getElementById(id);
      img.src = "";
      img.style.opacity = 0;
      input.nextElementSibling.classList.remove("show");
    }
  },

  getDeviceInfo() {
    var deviceinfo = navigator.userAgent;
    var deviceArr = deviceinfo.split(";");
    var data = {};
    data.resultCode = 0;
    data.result = {};
    data.result.osVersion = "";
    data.result.appVersion = "";
    data.result.phoneModel = "";
    for (var i = 0; i < deviceArr.length; i++) {
      var deviceVal = deviceArr[i];
      if (deviceVal.startsWith("nma-plf-ver2")) {
        data.result.osVersion = deviceVal.substr(deviceVal.indexOf("=") + 1);
      } else if (deviceVal.startsWith("nma-app-ver")) {
        data.result.appVersion = deviceVal.substr(deviceVal.indexOf("=") + 1);
      } else if (deviceVal.startsWith("nma-model")) {
        data.result.phoneModel = deviceVal.substr(deviceVal.indexOf("=") + 1);
      }
    }
    return data;
    // Native.execute("AppManager", "deviceInfo", callBack);
  },

  // baseSize
  getBaseSize() {
    return (
      Number(
        window
          .getComputedStyle(document.querySelector("html"))
          .fontSize.replace("px", "")
      ) / 10
    );
  },

  // 기관코드로 이름 가져오기
  async getOrgCodes(code) {
    if (!this.orgCodes) {
      const data = await Lib.get("/api/data/v2/lnkup/instts");
      this.orgCodes = data;
    }

    const orgCodes = this.orgCodes;
    const found = orgCodes.find((item) => {
      return item.insttCd === code;
    });
    return found;
  },

  getOrgName(code) {
    const item = orgCode.find((item) => {
      return item.orgCode === code;
    });
    return item?.orgName;
  },

  getIndustryType(code) {
    const item = orgCode.find((item) => {
      return item.orgCode === code;
    });
    return item?.industryType;
  },

  numberToKorean(number) {
    if (typeof number === "string") number = Number(number);
    var inputNumber = number < 0 ? false : number;
    var unitWords = ["", "만", "억", "조", "경"];
    var splitUnit = 10000;
    var splitCount = unitWords.length;
    var resultArray = [];
    var resultString = "";

    for (var i = 0; i < splitCount; i++) {
      var unitResult =
        (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
      unitResult = Math.floor(unitResult);
      if (unitResult > 0) {
        resultArray[i] = unitResult;
      }
    }

    for (var i = 0; i < resultArray.length; i++) {
      if (!resultArray[i]) continue;
      resultString =
        String(this.addComma(resultArray[i])) + unitWords[i] + resultString;
    }

    return resultString;
  },

  noLogo(e) {
    e.target.src = "/images/logo/noLogo.png";
  },

  // 차 번호 유효성 검사
  checkCarNumber(value) {
    if (!value) return;
    let NSValue = value.replace(/ /gi, "");
    let region = NSValue.substring(0, 2);

    const defaultRegions =
      "서울,부산,대구,인천,대전,광주,울산,제주,경기,강원,충남,충북,전남,전북,경남,경북";
    const regionData = defaultRegions.split(",");

    regionData.forEach((_region, _index) => {
      if (region === _region) {
        NSValue = NSValue.substring(2, NSValue.length);
        return false;
      }
    });

    let type = Number(NSValue.substring(0, 3));
    let typeOfCar;
    let use;
    let seriaNumber;

    if (isNaN(type)) {
      typeOfCar = Number(NSValue.substring(0, 2));
      use = NSValue.substring(2, 3);
      seriaNumber = NSValue.substring(3, value.length);
    } else {
      typeOfCar = Number(NSValue.substring(0, 3));
      use = NSValue.substring(3, 4);
      seriaNumber = NSValue.substring(4, value.length);
    }

    if (isNaN(typeOfCar) || typeOfCar <= 0) return false;

    let checkUse = `${"가,나,다,라,마,"}+${"거,너,더,러,머,버,서,어,저,"}+${"고,노,도,로,모,보,소,오,조,"}+${"구,누,두,루,무,부,수,우,주,"}+${"바,사,아,자,"}+${"배,"}+${"허,하,호,"}+${"국,합,육,해,공"}`;

    let arrCheckUse = checkUse.split(",");
    let resultUse = 0;

    arrCheckUse.forEach((_use, _index) => {
      if (use === _use) {
        resultUse = 1;
        return false;
      }
    });

    if (resultUse === 0) return false;

    if (isNaN(seriaNumber) || seriaNumber < 1000) return false;

    return true;
  },

  // blend two hex colors together by an amount
  blendColors(colorA, colorB, amount) {
    const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
    const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
    const r = Math.round(rA + (rB - rA) * amount)
      .toString(16)
      .padStart(2, "0");
    const g = Math.round(gA + (gB - gA) * amount)
      .toString(16)
      .padStart(2, "0");
    const b = Math.round(bA + (bB - bA) * amount)
      .toString(16)
      .padStart(2, "0");
    return "#" + r + g + b;
  },
  // 오늘 날짜 구하기
  getToDate() {
    let nowDate = this.GetServerDate();
    let nowYear = nowDate.getFullYear();
    let nowMonth = nowDate.getMonth() + 1;
    let nowDay = nowDate.getDate();

    if (nowMonth < 10) {
      nowMonth = "0" + nowMonth;
    }
    if (nowDay < 10) {
      nowDay = "0" + nowDay;
    }

    const todayDate = nowYear + "-" + nowMonth + "-" + nowDay;

    return todayDate;
  },

  // 오늘 월 구하기
  getToMonth() {
    let nowDate = this.GetServerDate();
    let nowMonth = nowDate.getMonth() + 1;

    if (nowMonth < 10) {
      nowMonth = "0" + nowMonth;
    }

    return nowMonth;
  },

  // n일 날자 구하기
  getCalDate(n, inputDate) {
    let now = this.GetServerDate(); // 현재 날짜 및 시간

    if (inputDate) {
      now = new Date(inputDate);
    }
    let beforeDayAgo = new Date(now.setDate(now.getDate() + n)); // + - n일

    let year = beforeDayAgo.getFullYear();
    let month = beforeDayAgo.getMonth() + 1;
    let day = beforeDayAgo.getDate();

    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }

    let date = year + "-" + month + "-" + day;

    //console.log("getBeforeCalDate date",date)
    return date;
  },

  //  몇달 이후 이전 날짜 구하기
  getCalMonthDate(n) {
    let now = this.GetServerDate(); // 현재 날짜 및 시간
    let oneMonthAgo = new Date(now.setMonth(now.getMonth() + n)); // n달 후

    oneMonthAgo = new Date(oneMonthAgo.setDate(oneMonthAgo.getDate()));

    let monthYear = oneMonthAgo.getFullYear();
    let monthMonth = oneMonthAgo.getMonth() + 1;
    let monthDay = oneMonthAgo.getDate();

    if (monthMonth < 10) {
      monthMonth = "0" + monthMonth;
    }
    if (monthDay < 10) {
      monthDay = "0" + monthDay;
    }

    let monthDate = monthYear + "-" + monthMonth + "-" + monthDay;

    return monthDate;
  },

  //서버 시간 거져오기
  GetServerDate() {
    var date = new Date();

    // try
    // {
    // 	var xmlHttpRequest = this.CreateHttpRequest();

    // 	xmlHttpRequest.open('HEAD', this.getDomainUrl(), false);
    // 	xmlHttpRequest.setRequestHeader("ContentType", "text/html");
    // 	xmlHttpRequest.send('');

    // 	var serverDate  = xmlHttpRequest.getResponseHeader("Date");
    // 	date            = new Date(serverDate);
    // }
    // catch (e) { }

    return date;
  },

  // Iphone  Date 타입변경
  //  new Date(2020,06,12,23,59,59) 2020년 07월 12일 23:59:59
  ChanageNewDate(strDate) {
    let dateArr = [];
    let timeArr = [];
    let returnDate;

    //console.log("this.getUserAgent()", this.getUserAgent());
    if (strDate) {
      if (this.getUserAgent() === "ios") {
        //console.log("strDate", strDate);
        if (strDate) {
          if (strDate.length === 10) {
            dateArr = strDate.split("-");
          } else if (strDate.length > 10) {
            dateArr = strDate.substring(0, 10).split("-");
            timeArr = strDate.substring(11).split(":");
          }
        }

        if (dateArr) {
          //console.log("dateArr", dateArr);
          if (dateArr.length === 3) {
            //console.log("timeArr", timeArr);
            if (timeArr.length >= 2) {
              if (timeArr.length === 2) {
                returnDate = new Date(
                  dateArr[0],
                  dateArr[1] - 1,
                  dateArr[2],
                  timeArr[0],
                  timeArr[1],
                  "00"
                );
              } else if (timeArr.length > 2) {
                returnDate = new Date(
                  dateArr[0],
                  dateArr[1] - 1,
                  dateArr[2],
                  timeArr[0],
                  timeArr[1],
                  timeArr[2]
                );
              } else {
                returnDate = new Date(
                  dateArr[0],
                  dateArr[1] - 1,
                  dateArr[2],
                  timeArr[0],
                  "00",
                  "00"
                );
              }
            } else {
              returnDate = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
            }
          } else {
            returnDate = new Date(strDate);
          }
        } else {
          returnDate = new Date(strDate);
        }
      } else {
        returnDate = new Date(strDate);
      }
    } else {
      returnDate = this.GetServerDate();
    }

    //console.log("returnDate", returnDate);
    return returnDate;
  },
  // 서버 도메인 구하기
  getDomainUrl() {
    var url = window.location.href.toString();

    url = url.split("//");
    url = url[0] + "//" + url[1].substr(0, url[1].indexOf("/"));

    return url;
  },
  /**
   * 좌측문자열채우기
   * @params
   *  - str : 원 문자열
   *  - padLen : 최대 채우고자 하는 길이
   *  - padStr : 채우고자하는 문자(char)
   */
  lpad(str, padLen, padStr) {
    if (padStr.length > padLen) {
      console.log("오류 : 채우고자 하는 문자열이 요청 길이보다 큽니다");
      return str;
    }

    str += ""; // 문자로
    padStr += ""; // 문자로

    while (str.length < padLen) str = padStr + str;
    str = str.length >= padLen ? str.substring(0, padLen) : str;

    return str;
  },
  // 이름 가운데 글자 마스킹 처리
  maskingName(strName) {
    if (!strName) {
      return strName;
    } else if (strName && strName.length > 2) {
      var originName = strName.split("");
      originName.forEach(function (name, i) {
        if (i === 0 || i === originName.length - 1) return;
        originName[i] = "*";
      });
      var joinName = originName.join();
      return joinName.replace(/,/g, "");
    } else {
      var pattern = /.$/; // 정규식
      return strName.replace(pattern, "*");
    }
  },

  checkMobile() {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      //안드로이드
      return "android";
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      //IOS
      return "ios";
    } else {
      //아이폰, 안드로이드 외
      return "other";
    }
  },

  // 문자열 공백 제거
  trim(val) {
    return val.replace(/^\s+|\s+$/g, "");
  },
  // 서버통신
  // CreateHttpRequest()
  // {
  // 	try
  // 	{
  // 		return new XMLHttpRequest();
  // 	}
  // 	catch (e)
  // 	{
  // 		try
  // 		{
  // 			return new ActiveXObject('Msxml2.XMLHTTP');
  // 		}
  // 		catch (e2)
  // 		{
  // 			return new ActiveXObject('Microsoft.XMLHTTP');
  // 		}
  // 	}
  // }
  deepCopy(obj) {
    if (!obj) return obj;
    return JSON.parse(JSON.stringify(obj));
  },

  nativeCall: (extension, method, args, callback) => {
    try {
      Native.execute(extension, method, callback, args);
    } catch (e) {
      console.log(
        `%cNot on a mobile device or an error occured. - %c${extension}, %c${method}`,
        "color: orange",
        "color:blue",
        "color: darkBlue"
      );
      console.log({ args });
    }
  },

  $(selector) {
    const elements = document.querySelectorAll(selector);
    if (elements && elements.length === 1) {
      return elements[0];
    } else {
      return elements;
    }
  },

  reqBlobFileDownlaod(blobUrl, fileName) {
    // BlobFile 다운로드 function
    const xhr = new XMLHttpRequest();
    xhr.open("GET", blobUrl, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    // 재판매 APi 연동시 헤더 추가
    if(blobUrl.indexOf(process.env.REACT_APP_MYAPI_SERVER) === 0) {
      const accessToken = window.localStorage.getItem("accessToken");
      if(accessToken) {
        xhr.setRequestHeader("Authorization", `Bearer ${accessToken}`);
      }
    }
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      if (this.status == 200) {
        const blob = this.response;
        
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          const base64data = reader.result;
        
          Native.execute("AppManager", "sharePlus", undefined, {
            type: "base64",
            filename: fileName,
            data: base64data,
          });
        };
      }
    };
    xhr.send();
  },
  // date format string : yyMMddHHmmssSSS
  getyyMMddHHmmssSSSSFormatString() {
    const currentTime = new Date()

    const year = `${currentTime.getFullYear()}`.substring(2)
    const month = currentTime.getMonth() + 1 > 9 ? `${currentTime.getMonth() + 1}` : `0${currentTime.getMonth() + 1}`
    const date = currentTime.getDate() > 9 ? `${currentTime.getDate()}` : `0${currentTime.getDate()}`
    const hours = currentTime.getHours() > 9 ? `${currentTime.getHours()}` : `0${currentTime.getHours()}`
    const min = currentTime.getMinutes() > 9 ? `${currentTime.getMinutes()}` : `0${currentTime.getMinutes()}`
    const sec = currentTime.getSeconds() > 9 ? `${currentTime.getSeconds()}` : `0${currentTime.getSeconds()}`
    const milSec = `${currentTime.getMilliseconds()}0`

    return `${year}${month}${date}${hours}${min}${sec}${milSec.padStart(4, '0')}`
  }
};
export default Lib;
